import React, { ReactElement, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ActionCreatorWithOptionalPayload } from '@reduxjs/toolkit';
import { CenteredSpinner } from '../../../../../../components';
import formStyles from '../../../EditFormStyles.module.css';
import { useGetNetworksQuery } from '../../../../../../redux/configuration/networks/api';
import { DeleteNetworkModal } from '../DeleteNetworkModal';
import { ViewAllNetworksModalContainer } from '../ViewAllNetworksModal/container';
import { AddNetwork } from './AddNetwork';
import { NetworkTable } from './NetworkTable';
import {
  convertInterfacesToOptions,
  resolveNetworkInterfaceNames,
} from './utils';

interface FormNetworkingProps {
  addNetworkInterface: (
    networkInterfaceFields: AddNetworkFields,
    networks: Network[],
  ) => void;
  hardware: Hardware;
  networkInterfaces: HardwareNetworkInterface[];
  onConfirmDelete: VoidFunction;
  onDeleteClick: (uid: string) => void;
  setViewAllNetworksModal: ActionCreatorWithOptionalPayload<
    string[] | undefined,
    string
  >;
}

export function FormNetworking({
  addNetworkInterface,
  hardware,
  networkInterfaces,
  onConfirmDelete,
  onDeleteClick,
  setViewAllNetworksModal,
}: FormNetworkingProps): ReactElement {
  const [networkInterfaceToDelete, setNetworkInterfaceToDelete] = useState('');
  const { uid: topologyUid } = useParams<EditTopologyParams>();
  const { data: networks } = useGetNetworksQuery(topologyUid);

  if (!networks) {
    return <CenteredSpinner />;
  }

  const networkInterfacesWithNames = networkInterfaces.map((item) =>
    resolveNetworkInterfaceNames(item, networks),
  );

  return (
    <div className={formStyles.sectionPadding}>
      <AddNetwork
        onAddClick={addNetworkInterface}
        networks={networks}
        interfaces={convertInterfacesToOptions(
          hardware.inventoryHardwareItem.networkInterfaces,
          networkInterfaces,
        )}
      />
      {!!networkInterfacesWithNames.length && (
        <NetworkTable
          networkInterfaces={networkInterfacesWithNames}
          networks={networks}
          onDeleteClick={onDeleteClick}
          setViewAllNetworksModal={setViewAllNetworksModal}
        />
      )}
      <ViewAllNetworksModalContainer />
      <DeleteNetworkModal
        onClose={() => setNetworkInterfaceToDelete('')}
        onConfirm={onConfirmDelete}
        show={!!networkInterfaceToDelete}
      />
    </div>
  );
}
